<template>
  <section id="orders">

    <h2 class="title">{{ $t('views.orders.title') }}</h2>
    <!-- <div class="desc">Revisa tu carrito y confirma tu pedido</div> -->

    <div class="main-content">
      <div class="list">
          <div class="empty" v-if="Object.keys( orders ).length == 0">
            {{ $t('views.orders.empty') }}
          </div>
          <div v-for="(order, index) in orders" class="order" :key="index">

          <div class="details" :class="{ 'open': openChats[order.id] }">
            <div class="meta">
              <div class="date">{{ $t('views.orders.date') }}{{ order.number }} {{ formatDate(order.date) }}
                <div :title="$t('views.orders.open_message')" class="button" @click="openOrder(order)">
                  <span>{{ $t('views.orders.open') }}</span>
                  <img src="/img/icons/down.png" alt="">
                </div>
              </div>
              <div class="status" :class="'s'+order.status" >
                <img :src="'/img/icons/status-' + order.status + '.png'" />
                <span>{{ $t('views.orders.status.' + order.status) }}</span>
              </div>
            </div>


            <div class="container">
              
              <div class="col-1">

                <h3 class="subtitle">{{ $t('views.orders.summary') }}</h3>

                <div class="orders">
                  <div v-for="(item, index) in order.items" class="item" :key="item.id">

                    <img class="image" :src="item.from.image" />

                    <div class="content">

                      <div class="to" >
                        <div class="name">{{item.from.filename}} <span class="print" v-if="item.method === 2">{{ $t('views.orders.production') }}</span> </div>
                        <div v-if="item.to.filename">
                          <div class="label">{{ $t('views.orders.adapt') }}</div>
                          <div v-if="sizes[item.to.file] && sizes[item.to.file][item.to.filename]">{{sizes[item.to.file][item.to.filename].name}}</div>
                          <div v-else>{{ item.to.filename }}</div>
                          <div v-if="item.to.size" class="size">{{ $t('views.orders.size') }}: {{item.to.size}}</div>
                        </div>


                        <div class="personalitzation" v-if="item.to.filename">
                          <div class="item title"><label>{{ $t('general.personalization') }}</label><span v-if="item.custom == null && !item.custom_file" class="value">{{ $t('general.no_personalization') }}</span></div>
                            <div class="item" v-if="item.custom != null && item.custom.restaurant && item.custom.restaurant != ''"><label>{{ $t('general.restaurant') }}</label><span class="value">{{ item.custom.restaurant }}</span></div>
                            <div class="item" v-if="item.custom != null && item.custom.price"><label>{{ $t('general.price') }}</label><span class="value">{{ item.custom.price }}</span></div>
                            <div class="item" v-if="item.custom != null && item.custom.legal"><label>{{ $t('views.order.customize.legal') }}</label><span class="value">{{ item.custom.legal }}</span></div>
                            <div class="item" v-if="item.custom != null && item.custom.schedule"><label>{{ $t('general.schedule') }}</label><span class="value">{{ item.custom.schedule }}</span></div>
                            <div class="item" v-if="item.custom != null && item.custom.date"><label>{{ $t('general.date') }}</label><span class="value">{{ item.custom.date }}</span></div>
                            <div class="item" v-if="item.custom_file"><label>{{ $t('general.file') }}</label><span class="value"><a :href="item.custom_file" target="_blank">{{ $t('general.download') }}</a></span></div>
                            <div class="item" v-if="item.custom != null && item.custom.others"><label>{{ $t('general.others') }}</label><span class="value">{{ item.custom.others }}</span></div>
                          </div>
                          <div class="questions">
                            <div class="item title" v-if="Object.keys( item.params ).length > 0"><label>{{ $t('general.questions') }}</label><span class="value"></span></div>
                            <div class="item" v-if="item.params.q1">
                              <label>{{ $t('views.orders.questions.cupouns') }}:</label>
                              <span v-if="item.params.q1 == 1" class="value">{{ $t('general.leave_confirm') }}</span>
                              <span v-if="item.params.q1 == 0" class="value">{{ $t('general.leave_cancel') }}</span>
                            </div>
                            <div class="item" v-if="item.params.q2">
                              <label>{{ $t('views.orders.questions.stamped') }}:</label>
                              <span v-if="item.params.q2 == 1" class="value">{{ $t('general.leave_confirm') }}</span>
                              <span v-if="item.params.q2 == 0" class="value">{{ $t('general.leave_cancel') }}</span>
                            </div>
                            <div class="item" v-if="item.params.q4">
                              <label>{{ $t('views.orders.questions.rounded') }}:</label>
                              <span v-if="item.params.q4 == 1" class="value">{{ $t('general.leave_confirm') }}</span>
                              <span v-if="item.params.q4 == 0" class="value">{{ $t('general.leave_cancel') }}</span>
                            </div>
                            <div class="item" v-if="item.params.q5">
                              <label>{{ $t('views.orders.questions.newspaper') }}:</label>
                              <span v-if="item.params.q5 == 1" class="value">{{ $t('views.orders.questions.magazine') }}</span>
                              <span v-if="item.params.q5 == 0" class="value">{{ $t('views.orders.questions.newspaper') }}</span>
                            </div>
                            <div class="item" v-if="item.params.q6">
                              <label>{{ $t('views.orders.questions.support') }}:</label>
                              <span v-if="item.params.q6 == 1" class="value">{{ $t('general.leave_confirm') }}</span>
                              <span v-if="item.params.q6 == 0" class="value">{{ $t('general.leave_cancel') }}</span>
                            </div>
                            <div class="item" v-if="item.params.q7">
                              <label>{{ $t('views.orders.questions.base') }}:</label>
                              <span v-if="item.params.q7 == 1" class="value">{{ $t('general.leave_confirm') }}</span>
                              <span v-if="item.params.q7 == 0" class="value">{{ $t('general.leave_cancel') }}</span>
                            </div>
                            <div class="item" v-if="item.params.q8">
                              <label>{{ $t('views.orders.questions.envelope') }}:</label>
                              <span v-if="item.params.q8 == 1" class="value">{{ $t('general.leave_confirm') }}</span>
                              <span v-if="item.params.q8 == 0" class="value">{{ $t('general.leave_cancel') }}</span>
                            </div>
                            <div class="item" v-if="item.params.custom_file"><label>* {{$t('general.file')}}</label><span class="value"><a :href="item.params.custom_file" target="_blank">{{ $t('general.download') }}</a></span></div>
                            <div class="item" v-if="item.params.custom"><label>* {{$t('general.others')}}</label><span class="value">{{ item.params.custom }}</span></div>
                          </div>
                      </div> 



                      <div v-if="item.method == 2">
                        <div class="param"><span class="label">{{ $t('general.unit') }}</span><b><span v-if="item.units">{{item.units}}</span><span v-if="item.units_scale && item.units_scale != -1">{{item.units_scale}}</span><span v-if="item.units_scale && item.units_scale == -1">{{item.units_scale_custom}}</span></b></div>
                        <div class="param" v-if="locations[item.shipped]"><span class="label">{{ $t('general.send_to') }}</span><b v-if="item.shipped">{{locations[item.shipped].site}} - {{locations[item.shipped].name}}</b><b v-else>{{item.custom_ship}}</b></div>
                      </div>
                      <div class="param" v-if="locations[item.billed]"><span class="label">{{ $t('general.invoice') }}</span><b>{{locations[item.billed].site}} - {{locations[item.billed].name}}</b></div>
                      
                    </div>

                  </div>
                  
                </div>
              </div>
              <div class="col-2">
                <h3 class="subtitle">{{ $t('general.contact') }}</h3>
                <div class="contact">
                  <div class="param"><span class="label">{{$t('general.name')}}:</span><b>{{order.contact_name}}</b></div>
                  <div class="param"><span class="label">{{$t('general.email')}}:</span><b>{{order.contact_email}}</b></div>
                  <div class="param" v-if="order.contact_phone"><span class="label">{{$t('general.phone')}}:</span><b>{{order.contact_phone}}</b></div>
                </div>
              </div>
            </div>

          </div>

          <div class="chat" :class="{ 'open': openChats[order.id] }" v-if="openChats[order.id]">
            <OrderChat :order_id="order.id" type="other" :autoLoad="false" />
          </div>
          
        </div>
      </div>
    </div>

  </section>
</template> 

<script>
import i18n from '@/i18n';
import OrderChat from '@/components/domain/order/chat.vue';

export default {
  name: 'Orders',
  components: {
    OrderChat
  },
  data () {
    return {
      //orders: [],
      sizes: this.$store.getters['orders/getSizes'],
      openChats: {}
    }
  },
  computed: {
      orders() {
        var orders = Object.values(this.$store.getters[ 'orders/getOrders' ]);
        orders = orders.sort(function(a, b) { return moment(b.date).unix() - moment(a.date).unix();});
        return orders;
      },
      locations() {
          return this.$store.getters['locations/getLocations']
      },

      orders_status() {
          return this.$store.getters['orders/getOrderStatus']
      }
  },
  methods: {
      formatDate( date ) {
          return moment( date ).format( "HH:mm DD/MM/YYYY" );
      },
      openOrder(order) {
        this.$router.push({ name: 'order_details', params: { id: order.id } });
      }
  },
  created() {
    this.$store.commit('setTitle', i18n.t('views.orders.name'));
    this.$store.commit('setMenuVisible', false);

    //this.orders = this.$store.getters[ 'orders/getOrders' ];
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .title {
    margin-top: 50px;
    margin-bottom: 10px;
  }
  .desc {
    font-size: 12pt;
  }


  .main-content {
    width: 80%;
    margin: 0 auto;
    margin-top: 35px;

    .subtitle {
      text-align: left;
      text-transform: uppercase;
      font-size: 16px;
    }

    .empty {
      font-size: 16px;
      color: #aaa;
      margin: 30vh 0px;
    }

   .list {
    width: 100%;
    margin-bottom: 50px;

    .meta {
      text-align: left;
      background: #ddd;
      padding: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .date {
        font-family: Speedee-Bold;
        font-size: 24px;
        display: inline-flex;
        align-items: center;

        .button {
          display: flex;
          align-items: center;
          margin-left: 8px;
          cursor: pointer;
          border-left: 1px solid #BDBDBD;
          img {
            height: 24px;
            width: 24px;
            rotate: -90deg;
          }
          span {
            color: #5D73B3;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            padding: 0 8px;
          }
        }
      }
      .status {
        display: inline-block;
        background: #ccc;
        border-radius: 4px;
        padding: 6px 16px;
        font-size: 14px;
        color: #111;
        float: right;
        display: flex;
        align-items: center;
        img {
          height: 16px;
          width: 16px;
          margin-right: 4px;
          display: inline-block;
          vertical-align: middle;
        }

        &.s1 {
          background-color: black;
          color: white;
          > img {
            filter: brightness(0) invert(1);
          }
        }

        &.s2 {
          background-color: #FFFFFF;
          color: #111111;
        }

        &.s3 {
          background-color: #ffeb3b;
          color: #111111;
        }
        
        &.s4 {
          background-color: #96d6be;
          color: #111111;
        }

        &.s5 {
          background-color: #ff9e80;
            color: #111111;
        }
      }
    }

    .order {
      margin-bottom: 25px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .details {
        width: 100%;
        border: 1px solid #ccc;
        transition: all 0.6s ease;

        &.open {
          width: 50%;
        }

        .container {
          overflow: hidden;

          .col-1 {
            width: 70%;
            float: left;
            border-right: 1px solid #ccc;
            padding: 10px 25px;
          }
          .col-2 {
            width: 30%;
            float: left;
            padding: 10px;
            padding-left: 25px;
          }
        }
      }

      .chat {
        width: 0;
        height: 100%;
        margin-left: 16px;
        transition: all 0.6s ease;
        opacity: 0;

        &.open {
          width: 50%;
          opacity: 1;
        }
      }
    }

    .orders {
      padding-right: 25px;
      margin-bottom: 25px;

      .item {
        width: 100%;
        display: block;
        padding: 10px 10px;
        overflow: hidden;
        text-align: left;

        .image {
          width: 80px;
          float: left;
          padding: 5px;
        }
        .content {
          width: calc( 100% - 80px );
          float: left;
          padding: 5px 15px;

          .to {
            margin-bottom: 15px;

            .label {
              text-transform: uppercase;
              margin-top: 5px;
              font-weight: bold;
            }

            .name {
              font-family: Speedee-Bold;

              .print {
                background: var(--main_color);
                padding: 3px 10px;
                border-radius: 15px;
                font-size: 10px;
                margin-left: 10px;
              }
            }
            .size {
              font-size: 13px;

            }

            .personalitzation, .questions {
              margin-top: 15px;

              .title {
                font-size: 14px !important;
                margin: 0;
                padding: 0;
                font-weight: bold;
              }
              .item {
                padding: 0;
                margin-top: 5px;

                label {
                  width: 125px;
                  display: inline-block;
                }
                span {
                  width: calc( 100% - 125px );
                  display: inline-block;
                  padding-left: 10px;
                }
              }

            }
          }
          .param {
            overflow: hidden;
            font-size: 12px;

            .label {
              color: #999;
              float: left;
              width: 100px;
            }

            b {
              font-weight: lighter;
            }
          }

        }
      }
     }
    }


   .contact {
    text-align: left;
    margin-bottom: 25px;
    overflow: hidden;

    .param {
      margin-bottom: 5px;
      overflow: hidden;
      font-size: 14px;

      .label {
        color: #999;
        float: left;
        width: 80px;
      }

      b {
        font-weight: lighter;
      }
      
   }
 }


  }


</style>
